import warningIcon from '@/assets/images/picto/warning.svg';
import errorIcon from '@/assets/images/picto/cross-circle.svg';
import successIcon from '@/assets/images/picto/checkmark-circle.svg';
import infoIcon from '@/assets/images/picto/info.svg';

const BUTTON_CLASSES = {
    // Pill, uppercase, semibold: the host site's button language (gobeletcup.fr).
    common: [
        'h-10',
        'flex',
        'items-center',
        'justify-center',
        'border',
        'rounded-full',
        'text-md',
        'font-semibold',
        'uppercase',
        'tracking-[0.3px]',
        'transition-color',
        'duration-300',
        'font-input-serif',
    ],
    disabled: ['cursor-not-allowed', 'opacity-25'],
    stick: {
        bottom: ['mt-3', 'fixed', 'bottom-6', 'left-1/2', 'transform', '-translate-x-1/2'],
    },
    types: {
        outlined: ['border', 'border-gray-200', 'text-gray-700', 'bg-white', 'data-[no-hover=false]:hover:bg-gray-100', 'shadow-none'],
        filled: [
            'border',
            'text-white',
            'bg-bg-primary',
            'data-[no-hover=false]:hover:bg-bg-secondary',
            'data-[no-hover=false]:hover:text-text',
            'shadow-none',
        ],
        text: ['!m-0', '!p-0', 'text-deepblue', 'border', 'text-darkblue', 'bg-transparent', 'shadow-none', 'border-border-primary'],
    },
};

const TOASTER_CONFIG = {
    info: {
        borderColor: 'hover:border-notifications-info-text border-notifications-info-bg duration-200',
        bgColor: 'bg-notifications-info-bg',
        icon: infoIcon,
        textColor: 'text-notifications-info-text',
    },
    success: {
        borderColor: 'hover:border-notifications-success-text border-notifications-success-bg duration-200',
        bgColor: 'bg-notifications-success-bg',
        icon: successIcon,
        textColor: 'text-notifications-success-text',
    },
    error: {
        borderColor: 'hover:border-notifications-error-text border-notifications-error-bg duration-200',
        bgColor: 'bg-notifications-error-bg',
        icon: errorIcon,
        textColor: 'text-notifications-error-text',
    },
    warning: {
        borderColor: 'hover:border-notifications-warning-text border-notifications-warning-bg duration-200',
        bgColor: 'bg-notifications-warning-bg',
        icon: warningIcon,
        textColor: 'text-notifications-warning-text',
    },
};

const ICON_CONFIG = {
    size: {
        xs: 'size-2.5',
        sm: 'size-3',
        md: 'size-4',
        lg: 'size-5',
        xl: 'size-8',
        xxl: 'size-10',
    },
} as const;

const LOADER_CONFIG = {
    background: 'bg-black/30',
};

export { BUTTON_CLASSES, ICON_CONFIG, LOADER_CONFIG, TOASTER_CONFIG };
